const refineRadarChartData = ({ data }) => {
  if (data && data.length > 0) {
    let refinedData = [];
    // Check if types are unique
    let results = data.reduce(function (map, obj) {
      map[obj.kpi_name] = obj.kpi_value;
      return map;
    }, {});

    for (const property in results) {
      // Check if there is a value

      if (results[property]) {
        refinedData.push({
          kpi_name: property,
          kpi_value: Math.round(results[property])
        });
      }
    }
    if (refinedData.length === 0) {
      refinedData = undefined;
    }

    return refinedData;
  }
  return false;
};

export { refineRadarChartData };
